module.exports = __webpack_public_path__ + "static/media/facebook01.322a35c1.png";